/**
 * HOC that converts immutable.js props to pure JS props.
 *
 * Useful since the Immutable.toJS() operation returns a new object on each
 * invocation, resulting in unneccesary rerenders if used directly in a
 * smart components mapStateToProps function [1].
 *
 * [1]: https://redux.js.org/docs/recipes/UsingImmutableJS.html#use-a-higher-order-component-to-convert-your-smart-components-immutablejs-props-to-your-dumb-components-javascript-props
 */

import React from 'react';
import { Iterable } from 'immutable';

export default WrappedComponent => wrappedComponentProps => {
  const KEY = 0;
  const VALUE = 1;
  const propsJS = Object.entries(wrappedComponentProps).reduce(
    (newProps, wrappedComponentProp) => {
      const wrappedProps = newProps;
      wrappedProps[wrappedComponentProp[KEY]] = Iterable.isIterable(
        wrappedComponentProp[VALUE]
      )
        ? wrappedComponentProp[VALUE].toJS()
        : wrappedComponentProp[VALUE];
      return wrappedProps;
    },
    {}
  );

  return <WrappedComponent {...propsJS} />;
};
